import { createContext as i, useContext as t } from "react";
const o = !1, s = void 0, l = void 0, E = "PERIOD", e = i({
  file: void 0,
  fileDecimalSeparator: E,
  fileEncoding: void 0,
  fileHasHeader: o,
  fileHeaders: l,
  fileValuesDelimiter: s,
  setFile: () => {
  },
  setFileEncoding: () => {
  },
  setFileHasHeader: () => {
  },
  setFileHeaders: () => {
  },
  setFileSeparators: () => {
  },
  setFileValuesDelimiter: () => {
  }
}), F = e.Provider, a = () => t(e);
export {
  E as DEFAULT_FILE_DECIMAL_SEPARATOR,
  o as DEFAULT_FILE_HAS_HEADER,
  l as DEFAULT_FILE_HEADERS,
  s as DEFAULT_FILE_VALUES_DELIMITER,
  e as FileContext,
  F as FileProvider,
  a as useFile
};
//# sourceMappingURL=FileContext.js.map
